import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { MainContainerComponent } from './learner/main-container.component';
import { AuthGuardGuard } from './shared-service/auth-guard.guard';
import { DeeplinkComponent } from './deeplink/deeplink.component';
import { AuthGuard } from './auth/auth.gaurd';


const appRoutes: Routes = [
	{
		path: '',
		redirectTo: '/login',
		pathMatch: 'full'
	},	
	{
		path: 'login',
		component: LoginComponent,
		canActivate: [AuthGuard]
	},
	{
		path: 'deeplink',
		component: DeeplinkComponent,
		canActivate: [AuthGuard],	
	},
	{
		path: 'unauthorized',
		component: UnauthorizedComponent
	},
	{
		path: 'learner',
		component: MainContainerComponent,
		canActivate: [AuthGuard],
		children: [
			{
				path: 'learning',
				canActivate: [AuthGuard],
				//loadChildren: 'app/learner/my-learning/my-learning.module#MyLearningModule'
				loadChildren: ()=> import('./learner/my-learning/my-learning.module').then(m=>m.MyLearningModule)
			},
			{
				path: 'taskList',
				canActivate: [AuthGuard],
				//loadChildren: 'app/learner/my-tasks/my-tasks.module#MyTasksModule'
				loadChildren: ()=>import('./learner/my-tasks/my-tasks.module').then(m=>m.MyTasksModule)
			},
			{
				path: 'training',
				canActivate: [AuthGuard],
				//loadChildren: 'app/learner/training-history/training-history.module#TrainingHistoryModule'
				loadChildren: ()=>import('./learner/training-history/training-history.module').then(m=>m.TrainingHistoryModule)
			},
			{
				path: 'conversation',
				canActivate: [AuthGuard],
				//loadChildren: 'app/learner/conversation/conversation.module#ConversationModule'
				loadChildren: ()=>import('./learner/conversation/conversation.module').then(m=>m.ConversationModule)
			},
			{
				path: 'video-library',
				canActivate: [AuthGuard],
				//loadChildren: 'app/learner/videos/video-library.module#VideoLibraryModule'
				loadChildren: ()=>import('./learner/videos/video-library.module').then(m=>m.VideoLibraryModule)
			},
			{
				path: 'dashboard-reports',
				canActivate: [AuthGuard],
				//loadChildren: 'app/learner/dashboard/dashboard.module#DashboardModule'
				loadChildren: ()=>import('./learner/dashboard/dashboard.module').then(m=>m.DashboardModule)
			},
			{
				path: 'skill-path',
				canActivate: [AuthGuard],
				//loadChildren: 'app/learner/skill-path/skill-path.module#SkillPathModule'
				loadChildren: ()=>import('./learner/skill-path/skill-path.module').then(m=>m.SkillPathModule)
			},
			{
				path: 'survey',
				canActivate: [AuthGuard],
				//loadChildren: 'app/learner/survey/survey.module#SurveyModule'
				loadChildren: ()=>import('./learner/survey/survey.module').then(m=>m.SurveyModule)
			},			
			{
				path: 'customer-care',
				canActivate: [AuthGuard],
				//loadChildren: 'app/learner/customer-care/customer-care.module#CustomerCareModule'
				loadChildren: ()=>import('./learner/customer-care/customer-care.module').then(m=>m.CustomerCareModule)
			},
			{
				path: 'system-alert',
				canActivate: [AuthGuard],
				//loadChildren: 'app/learner/system-alert/system-alert.module#SystemAlertModule'
				loadChildren: ()=>import('./learner/system-alert/system-alert.module').then(m=>m.SystemAlertModule)
			},
			{ 
				path: 'leaderboard',
				canActivate: [AuthGuard],
				//loadChildren: 'app/learner/leaderboard/leaderboard.module#LeaderboardModule'
				loadChildren: ()=>import('./learner/leaderboard/leaderboard.module').then(m=>m.LeaderboardModule)
			},
			{ 
				path: 'user-profile',
				canActivate: [AuthGuard],
				//loadChildren: 'app/learner/user-profile/user-profile.module#UserProfileModule'
				loadChildren: ()=>import('./learner/user-profile/user-profile.module').then(m=>m.UserProfileModule)
			},
			{ 
				path: 'external-learning',
				canActivate: [AuthGuard],
				//loadChildren: 'app/learner/external-learning/external-learning.module#ExternalLearningModule'
				loadChildren: ()=>import('./learner/external-learning/external-learning.module').then(m=>m.ExternalLearningModule)
			},
			{ 
				path: 'briefcase',
				canActivate: [AuthGuard],
				//loadChildren: 'app/learner/briefcase/briefcase.module#BriefcaseModule'
				loadChildren: ()=>import('./learner/briefcase/briefcase.module').then(m=>m.BriefcaseModule)
			},
			{
				path:'blog',
				canActivate:[AuthGuard],
				//loadChildren:'app/learner/blog/blog.module#BlogModule'
				loadChildren: ()=>import('./learner/blog/blog.module').then(m=>m.BlogModule)
			},
			{ 
				path: 'shop',
				canActivate: [AuthGuard],
				//loadChildren: 'app/learner/shop/shop.module#ShopModule'
				loadChildren: ()=>import('./learner/shop/shop.module').then(m=>m.ShopModule)
			},
			{ 
				path: 'overview',
				canActivate: [AuthGuard],
				//loadChildren: 'app/learner/overview/overview.module#OverviewModule'
				loadChildren: ()=>import('./learner/overview/overview.module').then(m=>m.OverviewModule)
			},
			{
				path:'webinar',
				canActivate:[AuthGuard],
				//loadChildren:'app/learner/webinar/webinar.module#WebinarModule'
				loadChildren: ()=>import('./learner/webinar/webinar.module').then(m=>m.WebinarModule)
			},
			{
				path:'compliance',
				canActivate:[AuthGuard],
				//loadChildren:'app/learner/compliance/compliance.module#ComplianceModule'
				loadChildren: ()=>import('./learner/compliance/compliance.module').then(m=>m.ComplianceModule)
			}
			
		]
	},
	{
		path: '**',
		redirectTo: '/login'
	},
];

@NgModule({
	imports: [
		RouterModule.forRoot(appRoutes,{
			useHash: true,
			initialNavigation: 'enabledNonBlocking',
			enableTracing: false
		})
	],
	exports: [RouterModule]
})
export class AppRoutingModule { }
